import { render, staticRenderFns } from "./TransactionProductSection.vue?vue&type=template&id=43c500e2&scoped=true"
import script from "./TransactionProductSection.vue?vue&type=script&lang=js"
export * from "./TransactionProductSection.vue?vue&type=script&lang=js"
import style0 from "./TransactionProductSection.vue?vue&type=style&index=0&id=43c500e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c500e2",
  null
  
)

export default component.exports